// extracted by mini-css-extract-plugin
export default {"wrapper":"style_wrapper__Qaxgr","canvas":"style_canvas__0SXmt","button":"style_button__vJEoi"};